module.exports = __webpack_public_path__ + "static/img/jingkangfu.9162c13.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/jingkangfu.jpg
// module id = 5N4j
// module chunks = 1